<template>
    <modal id="district-modal"
           v-model="showModal"
           :title="generateModalTitle('thana')"
           @submit="submitData"
           :loading="loading"
           :preloader="preloader">
        <form ref="form" :data-url="this.selectedUrl ? `${THANAS}/${formData.id}` : THANAS">
            <app-form-group
                    label="Name"
                    v-model="formData.name"
                    placeholder="Name"
                    :errorMessage="$errorMessage(errors, 'name')"
            />
            <app-form-group-selectable
                    type="select"
                    label="District"
                    v-model="formData.district_id"
                    fetch-url="select-able/districts"
                    :errorMessage="$errorMessage(errors, 'district_id')"
                    list-value-field="name"
                    chooseLabel="district"
            />
        </form>
    </modal>
</template>

<script>
    import FromHelperMixin from '../../../../Mixins/FormHelperMixin'
    import ModalMixin from '../../../../Mixins/ModalMixin'
    import {THANAS} from "../../../../Config/ApiUrl";

    export default {
        name: 'ThanasCreateEdit',
        mixins: [FromHelperMixin, ModalMixin],
        data() {
            return {
                THANAS
            }
        },
        methods: {
            afterSuccess({data}) {
                this.toastAndReload(data.message, 'police-table');
                this.$emit('input', false);
                $('#district-modal').modal('hide');
            }
        }
    }
</script>